module.exports = __webpack_public_path__ + "img/texture_4.3a5cc927.png";